// src/components/LanguagePicker.js
import { useTranslation } from "react-i18next";
import "./LanguagePicker.css";

export default function LanguagePicker({
  value = "en",
  onChange,
  disabled = false,
  label, // if not provided, we translate default label
}) {
  const { t, i18n } = useTranslation();

  function handleChange(e) {
    const lang = e.target.value;
    i18n.changeLanguage(lang); // immediate UI switch
    onChange?.(lang);          // parent persists
  }

  return (
    <div className="field small">
      <label>{label ?? t("profile.language.label")}</label>

      <div className={`input-bubble ${disabled ? "is-disabled" : ""}`}>
        <select value={value || "en"} disabled={disabled} onChange={handleChange}>
          <option value="en">{t("profile.language.options.en")}</option>
          <option value="sk">{t("profile.language.options.sk")}</option>
        </select>
      </div>
    </div>
  );
}